import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Button, Tooltip, Icon } from 'antd'
import { planos } from '../../constants'
// import modeloContrato from '../../images/modelo-contrato.pdf'
import { ReactComponent as  Lock } from '../../images/wallet/lock.svg'
import { connect } from 'react-redux'
import './sidebar.css'

const NovoContratoBtn = () => (
    <div className="novoContrato mt-3">
        <Link to="/contratos">
            <button type="button" className="btnGrafico">
                Novo Investimento
            </button>
        </Link>
    </div>
)

const NovoContratoBtnDisabled = () => (
    <div className="novoContratoDisabled mt-3">
        <Tooltip title="Por favor, verifique seus documentos.">
            <button type="button" className="btnGrafico">
                Novo Investimento
            </button>
        </Tooltip>
    </div>
)

// const ModeloContrato = () => (
//     <div className="novoContrato mt-3 mb-3">
//         <Link to={modeloContrato} target="_blank">
//             <button type="button" className="btnGrafico">
//                 Modelo de Contrato
//             </button>
//         </Link>
//     </div>
// )

class SideBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contratoSelected: 0,
            modalSenhaOpened: false,
            modalEnderecoOpened: false,
            modalBetaOpened: false,
            fillBackground: false,
            show: true,
            asaActive: false,
            investimentosActive: false,
            classIcon: '',
            heightWrapper: '0px',
            heightContratos: '0px',
            page: window.location.pathname,
            showCommission: process.env.REACT_APP_COMMISSION === 'true'
        }
    }

    openAsa = () => {
        if(this.state.asaActive) {
            this.setState({
                asaActive: false,
                heightWrapper: '0px',
            })
        } else {
            this.setState({
                asaActive: true,
                heightWrapper: '300px',
            })
        }
    }

    openInvestimentos = () => {
        if(this.state.investimentosActive) {
            this.setState({
                investimentosActive: false,
                heightContratos: '0px',
            })
        } else {
            this.setState({
                investimentosActive: true,
                heightContratos: '800px',
            })
        }
    }

    componentDidMount() {
        if(this.state.page === '/meusinvestimentos') {
            this.setState({
                investimentosActive: true,
                heightContratos: '800px'
            })
        }
    }

    render() {
        const { nivelVerificacao, permissao, tipoContrato, asaActive } = this.props
        const { showCommission, page, investimentosActive } = this.state
        
        return (
            <>
                <div className="wrapperSideBar">
                    <div className="d-flex justify-content-between pr-3">
                        {page === '/meusinvestimentos' ? (
                            <div className="d-flex align-items-center">
                                <label className="sideBarTitle tx-grey" role="button" onClick={this.openInvestimentos}>
                                    Portfólios
                                </label>
                                <Icon 
                                    type="down" 
                                    className={`dropdown-icon ml-2 ${investimentosActive ? 'dropdown-icon-open' : 'dropdown-icon-closed'}`}
                                    onClick={this.openInvestimentos}
                                />
                            </div>
                        ) : (
                            <Link className="sideBarTitle tx-grey" to="/meusinvestimentos">Portfólios</Link>
                        )}
                        {/* Regra comentada pois todos podem criar investimentos
                          {permissao === 0 || permissao === 1 || permissao === 5 || permissao === 4 || permissao == undefined ? <Lock className="mt-1" /> : '' }
                        */}
                    </div>
                    {
                        page === '/meusinvestimentos' &&
                    
                        <div style={{maxHeight: this.state.heightContratos, display: 'block', overflow: 'hidden', transition: 'max-height 0.25s ease-in'}}>
                            {this.props.spirit && this.props.spirit.length > 0 ? (
                                <Button className={`btnAcao ${tipoContrato === 0 || !asaActive && 'tabMenuActive'}`} onClick={this.props.handleClick(this.props.spirit[0].id || '', this.props.spirit[0].tipoContrato || '')}>
                                    Spirit 
                                </Button>
                            ) : ''}
                            {this.props.asa && this.props.asa.length > 0 ? (
                                this.props.asa.map((contrato) => (
                                    <Button key={contrato.id} className={`btnAcao mt-3 ${tipoContrato === contrato.tipoContrato && 'tabMenuActive'}`} onClick={this.props.handleClick(contrato.id || '', contrato.tipoContrato || '')}>
                                        {planos[contrato.tipoContrato] ? planos[contrato.tipoContrato].nome : 'Plano não encontrado'}
                                    </Button>
                                ))
                            ) : ''}
                            {<NovoContratoBtn /> }
                        </div>
                    }
                    <hr style={{color: "#F6F3FF", background: "#F6F3FF", borderColor: "#F6F3FF"}} />
                    
                    {/* Opção de Indicações - só aparece quando REACT_APP_COMMISSION é true */}
                    {showCommission && (
                        <div className="d-flex justify-content-between align-items-start pr-3 mt-4">
                            <div className="d-flex align-items-center">
                                {page === '/indicacoes' ? 
                                    <label className="sideBarTitle tx-grey active-menu">Indicações</label> : 
                                    <Link className="sideBarTitle tx-grey" to="/indicacoes">Indicações</Link>
                                }
                            </div>
                        </div>
                    )}
                    
                    {/* <div className="d-flex justify-content-between align-items-start pr-3 mt-4">
                        <div className="d-flex align-items-center">
                            <Link className="sideBarTitle tx-grey" to="/wallet">Wallet</Link>
                            <label className="beta ml-3">Breve</label>
                        </div>
                        {permissao === 0 || permissao === 2 || permissao === 4 || permissao === undefined ? <Lock className="mt-1" /> : ''}
                    </div> */}
                    
                    <Link className="sideBarTitle tx-grey mt-4 d-block" to="/minhaconta" id="meuperfil">Meu perfil</Link>
                </div>
            </>
        )
    }
}


export default SideBar